import { render, staticRenderFns } from "./policies_list.vue?vue&type=template&id=519a6512&scoped=true&"
import script from "./policies_list.vue?vue&type=script&lang=js&"
export * from "./policies_list.vue?vue&type=script&lang=js&"
import style0 from "./policies_list.vue?vue&type=style&index=0&id=519a6512&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519a6512",
  null
  
)

export default component.exports